module.exports = __webpack_public_path__ + "static/media/aquarider-10222_03.f759b032.png";